import { call, select, SagaReturnType } from "redux-saga/effects";
import { makeSelectAuthenticatedUserInfo } from "../../../../../containers/App/selectors";
import { isInternalOffice } from "../../../../../utils/isInternalOffice";
import dictionaryContractorsApi from "../contractors/contractors.api";
import { LocalCompanyDataConverter } from "../../../../../viewModels/Dictionaries/LocalCompanyDataConverter";

import { dictionaryApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";
import BitrixCompanyDto from "../../../../../dto/Dictionaries/BitrixCompanyDto";

import endPoints from "./bitrixClients.endpoints";
import { SearchBitrixClientsRequestDto } from "./bitrixClients.requestsDto";

const dictionaryBitrixClientsApi = {
  regular: function* (abortController?: AbortController) {
    const user: ReturnType<ReturnType<typeof makeSelectAuthenticatedUserInfo>> = yield select(makeSelectAuthenticatedUserInfo());
    if (isInternalOffice(user?.company.settings.officeType)) {
      const result: SagaReturnType<typeof dictionaryContractorsApi.nameInfo> = yield call(
        dictionaryContractorsApi.nameInfo,
        undefined,
        abortController,
      );
      return {
        ...result,
        success: result.success
          ? { ...result.success, payload: result.success.payload.map(LocalCompanyDataConverter.fromNameInfo) }
          : undefined,
      };
    }
    return (yield call(
      [dictionaryApiService, dictionaryApiService.Get],
      endPoints.regular,
      undefined,
      undefined,
      abortController,
    )) as ApiCallResult<Array<BitrixCompanyDto>>;
  },
  search: function* (dto: SearchBitrixClientsRequestDto) {
    const user: ReturnType<ReturnType<typeof makeSelectAuthenticatedUserInfo>> = yield select(makeSelectAuthenticatedUserInfo());
    if (isInternalOffice(user?.company.settings.officeType)) {
      const result: SagaReturnType<typeof dictionaryContractorsApi.nameInfo> = yield call(
        dictionaryContractorsApi.nameInfo,
        dto.companyType === "CLIENT" || dto.companyType === "CARRIER" ? [dto.companyType] : undefined,
      );
      return {
        ...result,
        success: result.success
          ? {
              ...result.success,
              payload: result.success.payload
                .filter((company) => company.name.toLowerCase().includes(dto.query.toLowerCase()))
                .slice(0, dto.limit ?? result.success.payload.length)
                .map(LocalCompanyDataConverter.fromNameInfo),
            }
          : undefined,
      };
    }
    return (yield call([dictionaryApiService, dictionaryApiService.Get], endPoints.search, undefined, dto)) as ApiCallResult<
      Array<BitrixCompanyDto>
    >;
  },
  getById: function* (id: number) {
    const user: ReturnType<ReturnType<typeof makeSelectAuthenticatedUserInfo>> = yield select(makeSelectAuthenticatedUserInfo());
    if (isInternalOffice(user?.company.settings.officeType)) {
      const result: SagaReturnType<typeof dictionaryContractorsApi.basicInfo> = yield call(dictionaryContractorsApi.basicInfo, id);
      return {
        ...result,
        success: result.success
          ? { ...result.success, payload: LocalCompanyDataConverter.fromBasicInfo(result.success.payload) }
          : undefined,
      };
    }
    return (yield call([dictionaryApiService, dictionaryApiService.Get], endPoints.byId(id))) as ApiCallResult<BitrixCompanyDto>;
  },
};

export default dictionaryBitrixClientsApi;
